import { __decorate } from "tslib";
import React, { Component } from 'react';
import { Cascader } from 'antd';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
const mapStateToProps = (rootState) => ({
    formItem: rootState.formItem,
});
// @ts-ignore
let CarPosition = class CarPosition extends Component {
    constructor(props) {
        super(props);
        this.change = (value, checkedOptions) => {
            this.setState({ value });
            this.triggerChange({ value }, checkedOptions);
        };
        this.triggerChange = (changedValue, checkedOptions) => {
            // Should provide an event to pass value to Form.
            const onChange = this.props.onChange;
            if (onChange) {
                const checkedoptions = checkedOptions.map((item) => {
                    return {
                        label: item.label,
                        value: item.value,
                    };
                });
                onChange(changedValue.value, checkedoptions);
            }
        };
        this.state = {
            value: props.value || [],
        };
        dispatch.formItem.getProvince({});
        this.loadCity = this.loadCity.bind(this);
    }
    static getDerivedStateFromProps(props) {
        if (props.hasOwnProperty('value')) {
            const useVal = (props.value || []).filter((v) => v !== undefined && v !== '');
            return {
                value: useVal,
            };
        }
        return null;
    }
    componentDidUpdate() {
        this.state.value.length > 0 && this.state.value[0] && dispatch.formItem.getCity({
            province: [{
                    soucheProviceCode: this.state.value[0],
                }],
            precision: this.props.precision,
        });
    }
    componentDidMount() {
        const { value = [] } = this.state;
        if (value) {
            value.length > 0 && value[0] && dispatch.formItem.getCity({
                province: [{
                        soucheProviceCode: value[0],
                    }],
                precision: this.props.precision,
            });
        }
    }
    loadCity(selectedValue) {
        dispatch.formItem.getCity({
            province: selectedValue,
            precision: this.props.precision,
        });
    }
    render() {
        const { carPositionList } = this.props.formItem;
        const { value = [] } = this.state;
        const selected = value.filter((v) => v !== '');
        return (<Cascader {...this.props.CascaderProps} allowClear value={selected} options={carPositionList} loadData={this.loadCity} fieldNames={{
            label: 'label',
            value: 'value',
            children: 'children',
        }} onChange={this.change} getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} style={this.props.selfStyle}/>);
    }
};
CarPosition.defaultProps = {
    CascaderProps: {
        placeholder: '请选择车辆所在地',
    },
    precision: 'province',
};
CarPosition = __decorate([
    connect(mapStateToProps, null, null, { forwardRef: true })
], CarPosition);
export default CarPosition;
